import styled from "styled-components";

export const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 35px 0;

  @media (min-width: 1300px) {
    height: 100vh;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vw;
  height: 800px;
  background: rgba(255, 255, 255, 0.35);
  box-shadow: 0 8px 32px 0 rgba(149, 114, 39, 0.37);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  position: relative;

  @media (min-width: 1300px) {
    flex-direction: initial;
    justify-content: center;
    height: 90vh;
  }

  img {
    width: 80vw;
    border-radius: 10px;

    @media (min-width: 500px) {
      max-height: 60vh;
      width: auto;
      max-width: 400px;
    }

    @media (min-width: 1300px) {
      margin: -100px 100px 50px 0;
      max-width: 500px;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2 {
    font-weight: bold;
    line-height: 40px;
    font-size: 20px;

    @media (min-width: 1300px) {
      font-size: 4vw;
      line-height: 150px;
    }
  }

  h3 {
    line-height: 22px;
    font-size: 14px;

    @media (min-width: 1300px) {
      font-size: 2vw;
      line-height: 50px;
    }
  }
`;

export const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 20px;
    background-color: #cdbee7;
    color: #2a0670;
    border-radius: 10px;
    font-size: 18px;
    font-weight: bold;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #2a0670;

    cursor: pointer;
  }
`;

export const Voltar = styled.div`
  display: flex;
  align-items: center;
  color: #2a0670;
  cursor: pointer;
  font-size: 18px;
  margin-bottom: 3vh;
`;
